export default __webpack_public_path__ + "static/media/RobotoCondensed-Regular.b76c8526.ttf";